import { type OrderId } from '../common/structs/orders/cart';

export const orders = () => ({
    single: (id: OrderId) => `/orders/${id}`,
    refund: (id: OrderId) => ({
        single: `/orders/${id}/refund`,
    }),
});
